import TableElementInterface from 'components/organisms/players-to-exchange/table-elements/table-element-interface';

export default class TableElement implements TableElementInterface {
    constructor(
        public className: string,
        public value: any,
    ) {}
}
